
import { put, takeLatest } from "redux-saga/effects";
import axiosCustom from '../../../../components/common/apiConfig';
import { handleNotificationAlertTrySelect , handleNotificationAlertCatch } from "../../../../components/method/handleNotificationAlert";

export const actionTypes = {
    checkStateCustomerSelect: "[checkStateCustomerSelect] Action",
    checkStateCustomerSelectAsync: "[checkStateCustomerSelectAsync] Action",
    checkStateCustomerRemove: "[checkStateCustomerRemove] Action",
    checkStateCustomerLoading: "[checkStateCustomerLoading] Action",
    
};

const initialState = {
    exist: null,
    loading:false,
};


export const select_check_state_customer_reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.checkStateCustomerSelect:
            return {
                ...state,
                exist: payload,
            }
            case actionTypes.checkStateCustomerLoading:
            return {
                ...state,
                loading: payload,
            }
            case actionTypes.checkStateCustomerRemove:
                return initialState
            default:
                return state
    }
}

function* handleWorker({ payload }) {
    
    yield put({ type: actionTypes.checkStateCustomerLoading, payload:true })
    let config = {
        url: "select_request",
        "token": "3cf61fab-b50a-410f-9d59-3357ee4706fe",
        "member_id": "_0zehXYBdxxYGfkX5_wd",
    }

    let data = {
        table: "gift_card",
        method_type: "check_state_customer",
        data: payload?.data ? payload?.data : {}
    } 


    try {
        let res = yield axiosCustom(config, data)

        let isOk = handleNotificationAlertTrySelect(res)
        if (!isOk) return

        yield put({ type: actionTypes.checkStateCustomerSelect, payload: res?.data?.response?.data?.exist })


    } catch  {
        handleNotificationAlertCatch()
    }
    finally{
        yield put({ type: actionTypes.checkStateCustomerLoading, payload:false })
    }


}


export function*  select_check_state_customer_worker () {

    yield takeLatest(actionTypes.checkStateCustomerSelectAsync, handleWorker)
}